import { getBaseCustomProps, getFormCustomProps } from '../../Utilities/types/SharedProps';
import { RadioCheckmark, RadioCheckmarkInner, RadioDescription, RadioInput, RadioLabel, RadioRoot } from './styles';
import * as meta from '../../meta-data.json';

export const overrides = (props: any, dataProps: any, dataAria: any) => {
	const { ...rest } = props;
	return {
		Root: {
			style: ({ $theme }: any) => {
				return RadioRoot($theme);
			},
			props: {
				'data-epo': `epo-radio-${meta.version}`,
				part: `epo-radio-${meta.version}`,
				className: props.className,
				...dataProps,
				...getBaseCustomProps(props),
			},
		},
		Label: {
			style: ({ $theme, $disabled }: any) => {
				return RadioLabel($theme, $disabled, props);
			},
		},
		Input: {
			style: ({ $theme }: any) => {
				return RadioInput($theme, props);
			},
			props: {
				id: props.id,
				...dataAria,
				...getFormCustomProps(props),
				tabIndex: props.tabIndex || 0,
			},
		},
		Description: {
			style: ({ $theme }: any) => {
				return {
					...RadioDescription(props.size),
				};
			},
			props: {
				'data-epo': `epo-radio-${meta.version}`,
				part: `epo-radio-${meta.version}`,
			},
		},
		RadioMarkOuter: {
			style: ({ $theme, $isFocused, $isHovered, $isActive, $disabled, $checked, $isIndeterminate }: any) => {
				return RadioCheckmark(
					$theme,
					$isFocused,
					$isHovered,
					$isActive,
					$disabled,
					$checked,
					$isIndeterminate,
					rest,
				);
			},
		},
		RadioMarkInner: {
			style: ({ $theme, $disabled, $checked }: any) => {
				return {
					...RadioCheckmarkInner($theme, $disabled, $checked),
				};
			},
		},
	};
};
